import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export const useThemeStore = defineStore('theme', () => {
  const stored = localStorage.getItem('theme');
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const isDark = ref(stored ? stored === 'dark' : prefersDark);

  function applyToDOM() {
    document.documentElement.classList.toggle('dark', isDark.value);
  }

  function toggle() {
    isDark.value = !isDark.value;
  }

  watch(isDark, (val) => {
    localStorage.setItem('theme', val ? 'dark' : 'light');
    applyToDOM();
  }, { immediate: true });

  return { isDark, toggle };
});
